import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  withCredentials: true,
});

// Attach JWT token from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ip_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Check if a JWT is past its exp claim (client-side, no secret needed)
function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true; // unparseable → treat as expired
  }
}

// Deduplication flag — prevents multiple parallel 401s each firing a redirect
let logoutInProgress = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url    = error.config?.url || '';

    // Never force-logout on public auth calls (login/register will legitimately
    // return 401 for wrong credentials — that shouldn't wipe the session)
    const isPublicAuthCall = /\/(login|register|forgot-password|reset-password|verify-email)/.test(url);

    if (status === 401 && !isPublicAuthCall && !logoutInProgress) {
      const token = localStorage.getItem('ip_token');

      // Only hard-logout when the token is genuinely expired or absent.
      // A 401 from a server restart / DB blip while the token is still valid
      // should NOT kick the user out — just reject the individual request.
      if (!token || isTokenExpired(token)) {
        logoutInProgress = true;
        localStorage.removeItem('ip_token');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
        // Reset after redirect so a fresh login session is clean
        setTimeout(() => { logoutInProgress = false; }, 3000);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
